import { useState, useEffect } from "react";
import { firestore } from "../firebase.js";
import { collection, doc, addDoc, getDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import '../css/Purchase.css';
import '../css/PurchaseModal.css'
import Logo from '../asset/logos.png'
import Agreebox from "./components/Agreebox";

function Purchase() {

  const [agree, setAgree] = useState(false); //주의사항
  const [vValue, setVValue] = useState(null);
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/purchaseform")
  }


  useEffect(() => {
    const fetchVValue = async () => {
      try {

        const docRef = doc(firestore, 'purchase_admin', 'bigpie');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          setVValue(data.v);  
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchVValue();
  }, []); 




        
const [modalOpenOne, setModalOpenOne] = useState(false);
const [modalOpenTwo, setModalOpenTwo] = useState(false);

const openModalOne = () => {
  setModalOpenOne(true);
};
const closeModalOne = () => {
  setModalOpenOne(false);
};

const openModalTwo = () => {
  setModalOpenTwo(true);
};
const closeModalTwo = () => {
  setModalOpenTwo(false);
};


const ModalOne = (props) => {

  const { open, close, header } = props;

  return (

    <div className={open ? 'openModalsp modalsp' : 'modalsp'}>
      {open ? (
        <section>

          <main>


          <div className="notice-body" style={{display:'block'}}>

          <span className="notice-contents">
                    <div className="notice-head">
                    <button className="close" onClick={close}>
                      &times;
                    </button>
                    </div>
          </span>

          <div className="notice-total">
                    <span className="notice-contents">
                    <div className="notice-title-first">
                    1. 1688 접속하기
                    </div>
                    <div className="notice-text">
                    <span>请登录</span> (로그인)을 클릭하여 로그인 페이지로 들어갑니다.
                    </div>
                    <div className="notice-img-1">

                    </div>

                   </span>


                  <span className="notice-contents">
                    <div className="notice-title">
                    2. 1688 로그인
                    </div>
                    <div className="notice-text">
                    계정동결 방지를 위해 모바일 QR코드로 로그인 합니다.<br/>
                    QR코드 로그인 아이콘을 클릭합니다.
                    </div>
                    <div className="notice-img-2">

                    </div>
                  </span>
                  

                  <span className="notice-contents">
                  <div className="notice-title">
                  3. QR코드 스캔
                  </div>
                  <div className="notice-text">
                  로그인이 완료 되어있는 모바일 1688 앱에서 스캔버튼을 눌러서 QR코드를 스캔합니다.
                  </div>
                  <div className="notice-img-3">

                  </div>
                  </span>
                  

                  <span className="notice-contents">
                  <div className="notice-title">
                  4. 원하는 제품 선택
                  </div>
                  <div className="notice-text">
                  구매가 확정된 제품 구매창으로 이동하거나 장바구니에 담긴 구매창으로 이동합니다.
                  </div>
                  <div className="notice-img-4">

                  </div>
                  </span>
                  
                  <span className="notice-contents">
                  <div className="notice-title">
                  5. 최종금액 확인
                  </div>
                  <div className="notice-text">
                  선택 완료된 옵션과 수량을 선택 후 결제페이지로 이동하여 최종 금액을 확인합니다. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> (배송비 포함 사항 꼭 확인)
                  </div>
                  <div className="notice-img-5">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  최종금액이 맞다면 오른쪽 하단 <span>去付款</span> (지불하러 가기)를 클릭합니다.
                  </div>
                  <div className="notice-img-6">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  다음 화면으로 넘어가서 오른쪽 상단 <span>找人代付</span> (대신결제)를 클릭합니다.
                  </div>
                  <div className="notice-img-7">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-title">
                  6. 결제대행 정보 입력하기
                  </div>
                  <div className="notice-text">
                  2개의 창에서 위에 있는 결제대행 요청 아이디 작성란(<span>好友的账户</span>)에<br/>
                  중달이닷컴 알리페이 아이디인 <strong>zhongdali888@163.com 을 입력</strong>합니다.<br/>
                  하단의 <strong>비고(留言)에 신청자의 영문명을 입력</strong>합니다.<br/>
                  </div>
                  <div className="notice-img-8">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-title">
                  7. 신청완료
                  </div>
                  <div className="notice-text">
                  결제대행 신청이 완료되었습니다. 수고하셨습니다!
                  </div>
                  <div className="notice-img-9">

                  </div>
                  </span>
        
        </div>
        </div>



          </main>
        

          <footer>
            <div className='introa'>
          </div>
          </footer>
        </section>
      ) : null}
    </div>
  );
};


const ModalTwo = (props) => {
  // 열기, 닫기, 모달 헤더 텍스트를 부모로부터 받아옴
  const { open, close, header } = props;

  return (
    // 모달이 열릴때 openModal 클래스가 생성된다.
    <div className={open ? 'openModalsp modalsp' : 'modalsp'}>
      {open ? (
        <section>

          <main>


          <div className="notice-body" style={{display:'block'}}>

          <span className="notice-contents">
                    <div className="notice-heads">
                    <button className="close" onClick={close}>
                      &times;
                    </button>
                    </div>
          </span>

          <div className="notice-total">
                    <span className="notice-contents">
                    <div className="notice-title-first">
                    1. 1688 접속하기
                    </div>
                    <div className="notice-text">
                    <span>请登录</span> (로그인)을 클릭하여 로그인 페이지로 들어갑니다.
                    </div>
                    <div className="notice-img-10">

                    </div>
                  </span>


                  <span className="notice-contents">
                  <div className="notice-title">
                  2. 1688 로그인
                  </div>
                  <div className="notice-text">
                  계정동결 방지를 위해 모바일 QR코드로 로그인 합니다.<br/>
                  QR코드 로그인 아이콘을 클릭합니다.
                  </div>
                  <div className="notice-img-11">

                  </div>
                  </span>
                  

                  <span className="notice-contents">
                  <div className="notice-title">
                  3. QR코드 스캔
                  </div>
                  <div className="notice-text">
                  로그인이 완료 되어있는 모바일 1688 앱에서 스캔버튼을 눌러서 QR코드를 스캔합니다.
                  </div>
                  <div className="notice-img-12">

                  </div>
                  </span>
                  

                  <span className="notice-contents">
                  <div className="notice-title">
                  4. 원하는 제품 선택
                  </div>
                  <div className="notice-text">
                  구매가 확정된 제품 구매창으로 이동하거나 장바구니에 담긴 구매창으로 이동합니다.
                  </div>
                  <div className="notice-img-13">

                  </div>
                  </span>
                  
                  <span className="notice-contents">
                  <div className="notice-title">
                  5. 최종금액 확인
                  </div>
                  <div className="notice-text">
                  선택 완료된 옵션과 수량을 선택 후 결제페이지로 이동하여 최종 금액을 확인합니다. <br/>(배송비 포함 사항 꼭 확인)
                  </div>
                  <div className="notice-img-14">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  최종금액이 맞다면 오른쪽 하단 <span>去付款</span> (지불하러 가기)를 클릭합니다.
                  </div>
                  <div className="notice-img-15">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-title">
                  6. <span>找人代付</span> (대신결제)가 보이지 않는다면?
                  </div>
                  <div className="notice-text">
                  알리페이 메인 홈페이지로 들어갑니다.
                  </div>
                  <div className="notice-img-16">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  개인 사용자 버튼을 클릭합니다.
                  </div>
                  <div className="notice-img-17">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  마이페이지로 들어갑니다.
                  </div>
                  <div className="notice-img-18">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  거래 기록으로 들어갑니다.
                  </div>
                  <div className="notice-img-19">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-text">
                  이제 <span>找人代付</span> (대신결제)를 진행할 수 있습니다!
                  </div>
                  <div className="notice-img-20">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-title">
                  7. 결제대행 정보 입력하기
                  </div>
                  <div className="notice-text">
                  2개의 창에서 위에 있는 결제대행 요청 아이디 작성란(<span>好友的账户</span>)에<br/>
                  중달이닷컴 알리페이 아이디인 <strong>zhongdali888@163.com 을 입력</strong>합니다.<br/>
                  하단의 <strong>비고(留言)에 신청자의 영문명을 입력</strong>합니다.
                  </div>
                  <div className="notice-img-21">

                  </div>
                  </span>

                  <span className="notice-contents">
                  <div className="notice-title">
                  8. 신청완료
                  </div>
                  <div className="notice-text">
                  결제대행 신청이 완료되었습니다. 수고하셨습니다!
                  </div>
                  <div className="notice-img-22">

                  </div>
                  </span>
                  </div>
        
        </div>


          </main>
        

          <footer>
            <div className='introa'>
          </div>
          </footer>
        </section>
      ) : null}
    </div>
  );
};


  return (
<div className="purchase-full">

  <div className="purchase-nav">
  <a href="https://www.jungdari.com/"
       rel="noopener noreferrer">
        <img src={Logo} alt="Logo" style={{ width: "140px", padding:"10px 0px", paddingLeft:"14px"}} />
      </a>
      <ul className="purchase-ul">
      <li style={{ display: "inline-block" }}>
      </li>
      <li style={{ display: "inline-block", marginLeft: "9rem" }}>
      </li>
      <li style={{ display: "inline-block", marginLeft: "9rem" }}>
      </li>
      <li style={{ display: "inline-block", marginLeft: "9rem" }}>
      </li>

      <a href="https://www.jungdari.com/member/register.do"
         target="_blank"
         rel="noopener noreferrer">
      <li className="purchase-signup">
        중달이닷컴 회원가입
      </li>
      </a>
      </ul>
  </div>

  <div className="purchase-banner">

    <div className="purchase-banner-img">

    </div>

  </div>

  <div className="purchase-body">

    <div className="purchase-block-one">
    
    </div>

    {/*
    <div className="purchase-block-two">
      <div className="block-two">
      <div className="block-button-1" onClick={openModalOne}></div>
      <div className="block-button-2" onClick={openModalTwo}></div>
        <ModalOne open={modalOpenOne} close={closeModalOne}>
        </ModalOne>
        <ModalTwo open={modalOpenTwo} close={closeModalTwo}>
        </ModalTwo>
      </div>
    </div>
    */}

    <div className="purchase-block-three">
    
    </div>

    <div className="purchase-block-four">
      이용안내
    </div>

    <div className="purchase-block-five">
    <div className="inner-text">
    -중달이닷컴 결제대행은 중국 판매사이트 1688 안전거래 및 중국 현지 은행 간 계좌이체 서비스만 제공하고 있습니다.<br/><br/>
-중달이닷컴 회원가입 후 서비스 이용을 진행해 주세요.<br/><br/>
-결제대행 단독 서비스만 이용 가능합니다. (배송대행 서비스가 필요하신 고객님께서는 중국 업체와 직접 소통하시어 중달이 중국 지사 주소 전달 부탁드립니다.)<br/><br/>
-중달이닷컴 결제대행은 <strong>소통</strong> 서비스를 제공하지 않습니다. 제품 옵션, 수량, 중국 내 도착지 등은 직접 소통해 주세요<br/><br/>
-중달이닷컴 결제대행 서비스는 제품의 <strong>수입 요건, 품질 확인, 불량, 물류 핸들링, 공장과의 협상</strong> 등의 서비스는 불포함 사항입니다. <br/><br/>
-결제대행 신청 후 공휴일, 미운영시간, 기타요인 외에 <strong>24시간 내</strong> 서비스 처리 예정입니다.<br/><br/>
-결제대행 신청 시 주의사항을 꼼꼼하게 읽고 진행해 주세요.<br/><br/>
-결제대행 내부 고시 환율은 구매대행 및 배송대행 고시 환율과 상이하며 고시 환율은 매주 업데이트 됩니다. (신청서 작성 완료 시 자동으로 환산되어 견적서에서 바로 확인 가능합니다.)<br/><br/> 
-결제대행 신청서 작성 후 결제대행 비용 확인과 요청 절차 확인이 필요합니다.<br/><br/>
-결제대행 신청서 작성 완료 버튼을 눌러서 제출해 주시면 최종 견적서가 신청완료 화면에 나타나며, 동시에 작성해 주신 이메일로 발송됩니다.해당 견적 금액 내용을 확인하시고, 입금을 진행해 주세요.<br/><br/>
</div>
    </div>

    <div className="purchase-block-four">
      신청서 안내
    </div>

    <div className="purchase-block-five">
    <div className="inner-text">
-결제 요청 금액을 정확하게 입력해 주세요.<br/><br/>
-결제대행 금액은 결제대행 단독 환율에 따라서 적용이 되며,  아래의 절차로 진행됩니다.<br/><br/>
①입력하신 1688사이트 결제대행 요청금액(위안화)  ②중달이닷컴 결제대행 수수료 적용  ③총금액의 결제대행 단독 고시환율 적용 금액(한화)<br/><br/>
<br/><br/>
-수수료는 중달이닷컴 기준 화폐단위(KRW)로 됩니다.<br/><br/>
(<strong>총 신청금액 <span>{vValue}</span> 위안 미만의 경우 10,000원</strong>)<br/><br/>
-결제대행 수수료 및 수수료의 부가세에 대해 세금계산서 또는 현금영수증 발행이 가능합니다.<br/><br/>
<strong>*사업자로 진행하시는 분들은 반드시 사업자명으로 입금해주세요</strong><br/><br/>
-수수료 금액은 부가세 포함 금액으로 견적서가 전달됩니다.<br/><br/>
</div>
    </div>

    <div className="purchase-block-four">
      서비스 운영시간 안내
    </div>

    <div className="purchase-block-five">
      <div className="inner-text">
      -서비스 이용 시간 : 9:00-18:00 (월-금)<br/>
      *17시 이후 신청 건은 다음날 처리될 수 있습니다.<br/><br/>
<br/><br/>
-결제대행 신청 후 24시간 이내에 서비스 처리됩니다.<br/><br/>
-고시환율 적용 기간 : 매일 00시에 업데이트 됩니다. (신청서는 매일 00시에 당일 고시환율로 적용됩니다.)<br/><br/> 
-취소, 환불, 교환 : 공장의 단순 비협조, 제품의 오입고, 재고부족으로인한 취소, 환불이 필요한 경우에는 제품가만 환불이 가능합니다.<br/><br/>
<strong>수수료 금액은 환불이 어려운 점 확인 부탁드립니다.</strong><br/><br/>
-취소, 환불 절차 안내 : 중달이닷컴 홈페이지 채널톡을 이용해서 별도문의 부탁드립니다.<br/><br/> 
      </div>
    </div>

    <div className="purchase-block-six">

      <div className="block-six-text">
      <Agreebox checked={agree} onChange={setAgree}>
        주의사항을 모두 숙지하였으며,     
        <a href="https://jungdari.com/suport/terms.do"
         target="_blank"
         rel="noopener noreferrer"> <strong>이용약관</strong></a> 및 
                 <a href="https://jungdari.com/suport/privacy.do"
         target="_blank"
         rel="noopener noreferrer"> <strong>개인정보취급방침</strong></a>에 동의합니다.
      </Agreebox>
      </div>

      <button className="block-six-btn" disabled={!agree} onClick={onClick}>
        신청하기
      </button>

    </div>

  </div>

 
<div className="purchase-block-seven">

    <div className="block-seven-text">

    <div className="seven-top">

        <div className="seven-left">
    <a href="https://jungdari.com/suport/terms.do"
         target="_blank"
         rel="noopener noreferrer">이용약관</a>&nbsp;&nbsp;|&nbsp;&nbsp;  
        <a href="https://jungdari.com/suport/privacy.do"
         target="_blank"
         rel="noopener noreferrer">개인정보취급방침</a>
        &nbsp;&nbsp;|&nbsp;&nbsp;               
        <a href="https://jungdari.com/suport/terms2.do"
         target="_blank"
         rel="noopener noreferrer">개인정보의 수집 및 이용목적</a>
         </div>

         <div className="seven-right">
        고객문의 070-7776-1688
        </div>
    </div>

    <div className="seven-bottom">

        <div className="footer">

        <div className="footer-left">
    <p>상호:(주)빅파이씨앤티 | 사업자 등록번호 : 169-81-00496 | 전화번호 : 070-7776-1688 | 팩스번호 : 032-714-3850</p>
    <p>경기도 부천시 조마루로 385번길 122 삼보테크노타워 2702-3호 (주)빅파이씨앤티</p>
    <p>대표이사: 이중엽 | 통신판매 신고번호 : 제 2021-경기부천-1209호 | 개인정보보호책임자 : 양지연 | 메일: pi@jungdari.com</p>
    <p>Copyrights2020ⓒBigpieC&T. All Rights Reserved</p>
    </div>

    <div className="footer-right">
        <div className="footer-img"></div>
    </div>

    </div>

    </div>
    </div>
      
  </div>


</div>
  );
}

export default Purchase;
